// vars referenced by multiple components

const env = import.meta.env

export default {
  spaceZoom: {
    max: 300,
    min: 20,
    default: 100
  },
  viewportObserverMaxRootMarginPercent: 50,
  mediaZoomLevels: [0.25, 0.5, 1], // media is loaded at the smallest level that covers the current zoom
  spaceBetweenCards: 12,
  cardCharacterLimit: 4000,
  spaceNoteCharacterLimit: 10000,
  defaultCardWidth: 58,
  defaultCardHeight: 70,
  minItemXY: 70,
  minLineY: 90,
  minLineYOutdent: 175,
  minListWidth: 200,
  normalCardWrapWidth: 200,
  wideCardWrapWidth: 390,
  minCardIframeWidth: 310,
  freeCardsCreatedLimit: 100,
  freeUploadSizeLimit: 5, // 5mb
  upgradedUploadSizeLimit: 256, // 256mb
  emptyCard () {
    return { width: this.defaultCardWidth, height: 32 }
  },
  defaultDialogWidth: 250,
  minBoxSize: 70,
  defaultBoxWidth: 224,
  defaultBoxHeight: 105,
  itemSnapGuideWaitingDuration: 200,
  maxInviteEmailsAllowedToSend: 15,
  defaultConnectionPathCurveControlPoint: 'q90,40',
  straightLineConnectionPathControlPoint: 'q00,00',
  requestTimeout: 40000, // 40s
  rootUserId: 'euGhpBrR9eBcjKnK16C_g',
  sidebarWidth: 250,
  systemCommands: { explore: 'Explore', newSpace: 'New', templates: 'Templates', apps: 'Apps and Extensions' },
  isSecureAppContextIOS: navigator.isSecureAppContextIOS, // true = iOS app
  isSecureAppContext: navigator.isSecureAppContext, // true = iOS app
  isAndroid: false,
  cdnHost: 'https://cdn.kinopio.club',
  imgproxyHost: 'https://img.kinopio.club',
  defaultSpaceBackground: 'https://bk.kinopio.club/squiggle-background-2x.png',
  moderatorUserId: 'euGhpBrR9eBcjKnK16C_g',
  uploadPlaceholder: '⬬⬭',
  itemTypesWithPositions: ['boxes', 'cards', 'lists', 'lines'],
  nameDateFormat: 'MMMM D, YYYY', // August 16, 2025
  isStaticPrerenderingPage: env.SSR,
  lineInfoOffset: 11,
  listPadding: 8,
  listInfoHeight: 34,
  listEmptyHeight: 56,
  itemSnapOpacity: 0.5,
  itemSnapAlignThreshold: 10,
  edgeThreshold: 30,
  maxItemZ: 999999 - 1000,
  itemTypes: ['cards', 'connections', 'boxes', 'lists', 'lines', 'drawingStrokes'],
  isDevelopment () {
    if (env.VITE_PROD_SERVER === 'true') {
      return false
    } else {
      return (env.MODE === 'development')
    }
  },
  kinopioDomain () {
    let domain = 'https://kinopio.club'
    if (this.isDevelopment()) {
      domain = 'https://kinopio.local:8080'
    }
    return domain
  },
  apiHost (shouldUseProduction) {
    let host = 'https://api.kinopio.club'
    if (this.isDevelopment() && !shouldUseProduction) {
      host = 'https://kinopio.local:3000'
    }
    return host
  },
  websocketHost () {
    let host = 'wss://api.kinopio.club'
    if (this.isDevelopment()) {
      host = 'wss://kinopio.local:3000'
    }
    return host
  },
  helperServerHost () {
    let host = 'https://helper.kinopio.club'
    if (this.isDevelopment()) {
      host = 'https://kinopio.local:8082'
    }
    return host
  },
  userPrefersReducedMotion () {
    const query = window.matchMedia('(prefers-reduced-motion: reduce)')
    if (query.matches) {
      return true
    } else {
      return false
    }
  },
  drawingBrushSizeDiameter: {
    xs: 3,
    s: 10,
    m: 20,
    l: 40
  },

  // about

  roadmapSpaceId () {
    if (this.isDevelopment()) {
      return 'i6l8R_lSxtsSr3roZ_IEV'
    } else {
      return '3CBHtivu7X7nTzrcaTFQV'
    }
  },
  changelogSpaceId () {
    if (this.isDevelopment()) {
      return 'Y21yhTMPRE2uFSSplLtHR'
    } else {
      return '6lsytK8ZfOtMl2oqG05Rj'
    }
  },
  affiliateSpaceId () {
    if (this.isDevelopment()) {
      return '1kR5AsvvdpD7x2zxjHLh9'
    } else {
      return 'YNmS6C3fofN3R9mYgO1Bu'
    }
  },

  // price

  prices: {
    standard: {
      mo: {
        price: 8,
        priceId: 'price_1S2cymDFIr5ywhwoxYQpjwwx',
        devPriceId: 'price_1S2YjKDFIr5ywhwo9bTroXjb'
      },
      yr: {
        price: 80,
        priceId: 'price_1S2czcDFIr5ywhwoCiJ3UJFl',
        devPriceId: 'price_1S2YkjDFIr5ywhworJlITrlm'
      },
      life: {
        price: 250,
        priceId: 'price_1S2dCuDFIr5ywhwouB7Mpatd',
        devPriceId: 'price_1S2dahDFIr5ywhwoasGBlzaH'
      }
    },
    education: {
      mo: {
        price: 4,
        priceId: 'price_1S2d01DFIr5ywhwom6FcmrBE',
        devPriceId: 'price_1S2dWBDFIr5ywhwowrCrnKpt'
      },
      yr: {
        price: 40,
        priceId: 'price_1S2d0XDFIr5ywhwoDHendW1U',
        devPriceId: 'price_1S2dWKDFIr5ywhwoioe6WQAo'
      },
      life: {
        price: 200,
        priceId: 'price_1SZYkQDFIr5ywhwoVPO24ScV',
        devPriceId: 'price_1TSKwJDFIr5ywhwo9oqHxNIn'
      }
    },
    apple: {
      mo: {
        price: 9,
        priceId: 'apple_monthly_2025'
      },
      yr: {
        price: 90,
        priceId: 'apple_yearly_2025'
      }
    }
  },
  price (period, isStudentDiscount) {
    if (period === 'month') {
      return this.monthlyPrice(isStudentDiscount)
    } else if (period === 'year') {
      return this.yearlyPrice(isStudentDiscount)
    } else if (period === 'life') {
      return this.lifetimePrice(isStudentDiscount)
    }
  },
  // mo
  monthlyPrice (isStudentDiscount) {
    if (isStudentDiscount) {
      return this.monthlyStudentPrice()
    } else {
      return this.monthlyStandardPrice()
    }
  },
  monthlyStudentPrice () {
    if (this.isSecureAppContextIOS) {
      return this.monthlyStandardPrice()
    }
    const price = {
      amount: this.prices.education.mo.price,
      period: 'year',
      stripePriceId: this.prices.education.mo.priceId
    }
    if (this.isDevelopment()) {
      price.stripePriceId = this.prices.education.mo.devPriceId
    }
    return price
  },
  monthlyStandardPrice () {
    const price = {
      amount: this.prices.standard.mo.price,
      period: 'month',
      stripePriceId: this.prices.standard.mo.priceId,
      applePriceId: this.prices.apple.mo.priceId
    }
    if (this.isDevelopment()) {
      price.stripePriceId = this.prices.standard.mo.devPriceId
    }
    if (this.isSecureAppContextIOS) {
      price.amount = this.prices.apple.mo.price
    }
    return price
  },
  // yr
  yearlyPrice (isStudentDiscount) {
    if (isStudentDiscount) {
      return this.yearlyStudentPrice()
    } else {
      return this.yearlyStandardPrice()
    }
  },
  yearlyStandardPrice () {
    const price = {
      amount: this.prices.standard.yr.price,
      period: 'year',
      stripePriceId: this.prices.standard.yr.priceId,
      applePriceId: this.prices.apple.yr.priceId
    }
    if (this.isDevelopment()) {
      price.stripePriceId = this.prices.standard.yr.devPriceId
    }
    if (this.isSecureAppContextIOS) {
      price.amount = this.prices.apple.yr.price
    }
    return price
  },
  yearlyStudentPrice () {
    if (this.isSecureAppContextIOS) {
      return this.yearlyStandardPrice()
    }
    const price = {
      amount: this.prices.education.yr.price,
      period: 'year',
      stripePriceId: this.prices.education.yr.priceId
    }
    if (this.isDevelopment()) {
      price.stripePriceId = this.prices.education.yr.devPriceId
    }
    return price
  },
  // life
  lifetimeStandardPrice () {
    const price = {
      amount: this.prices.standard.life.price,
      period: 'life',
      stripePriceId: this.prices.standard.life.priceId
    }
    if (this.isDevelopment()) {
      price.stripePriceId = this.prices.standard.life.devPriceId
    }
    return price
  },
  lifetimeStudentPrice () {
    const price = {
      amount: this.prices.education.life.price,
      period: 'life',
      stripePriceId: this.prices.education.life.priceId
    }
    if (this.isDevelopment()) {
      price.stripePriceId = this.prices.education.life.devPriceId
    }
    return price
  },
  lifetimePrice (isStudentDiscount) {
    if (isStudentDiscount) {
      return this.lifetimeStudentPrice()
    } else {
      return this.lifetimeStandardPrice()
    }
  }

}
